<iframe id="external-link" [src]="externalUrl" allowfullscreen allow="autoplay"></iframe>
